import React from 'react'
import type { ObjectFieldTemplateProps } from '@rjsf/core'
import { DangerouslyHTML } from 'experiences/shared/DangerouslyHTML'
import { PendingFC } from 'components/patterns/suspense/componentWrappers'
import { Nullable } from 'lib'
import { Skeleton, Text, View } from 'reshaped/bundle'

export const ObjectFieldTemplate: PendingFC<ObjectFieldTemplateProps> = ({
	title,
	description,
	properties,
	pending
}) => {
	let fields, titleElement: Nullable<JSX.Element>
	if (pending) {
		titleElement = <Skeleton width={80} height={4} />
		fields = (
			<>
				<Skeleton width={60} height={4} />
				<Skeleton width={40} height={8} />
				<Skeleton width={60} height={4} />
			</>
		)
	} else {
		titleElement = title ? (
			<View gap={2}>
				<Text variant="title-6" as="h2">
					{title}
				</Text>
				{description && <DangerouslyHTML content={description} />}
			</View>
		) : null
		fields = <>{properties?.map((element: any) => <div key={element.name}>{element.content}</div>)}</>
	}

	return (
		<View gap={5}>
			{titleElement}
			{fields}
		</View>
	)
}
